import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { fetchRepBadges, fetchRepMe } from "./repServices";

// Rep Mode shell state: the attention badge on the header mail icon and the
// rep's own Rep ID / agency (shown in the header menu and the share modal).

const RepModeContext = createContext(null);

export const RepModeProvider = ({ children }) => {
  const [badges, setBadges] = useState({ attention: 0, athletes: 0 });
  const [me, setMe] = useState({ repCode: "", agency: "", firstName: "", lastName: "", athletes: 0 });
  const [sharing, setSharing] = useState(false);

  const refreshBadges = useCallback(async () => {
    try {
      const data = await fetchRepBadges();
      if (data) setBadges({ attention: data.attention || 0, athletes: data.athletes || 0 });
    } catch (err) {
      // decorative
    }
  }, []);

  const refreshMe = useCallback(async () => {
    try {
      const data = await fetchRepMe();
      if (data) setMe(data);
    } catch (err) {
      // the pages still work without the Rep ID card
    }
  }, []);

  useEffect(() => {
    refreshBadges();
    refreshMe();
    const timer = setInterval(refreshBadges, 60000);
    return () => clearInterval(timer);
  }, [refreshBadges, refreshMe]);

  const openShare = useCallback(() => setSharing(true), []);
  const closeShare = useCallback(() => setSharing(false), []);

  const value = useMemo(
    () => ({ badges, refreshBadges, me, refreshMe, sharing, openShare, closeShare }),
    [badges, refreshBadges, me, refreshMe, sharing, openShare, closeShare],
  );
  return <RepModeContext.Provider value={value}>{children}</RepModeContext.Provider>;
};

export const useRepMode = () => {
  const ctx = useContext(RepModeContext);
  if (!ctx) throw new Error("useRepMode must be used inside RepModeProvider");
  return ctx;
};
